import React from 'react';
import styled from 'styled-components';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  background: #fefefe;
  padding: 1rem;
  position: relative;
  width: 80%;
  max-width: 800px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: none;
  border: 1px solid #800020;
  color: #800020;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
`;

function BigRingViewer({ modelPath }) {
  const { scene } = useGLTF(modelPath);
  return (
    <>
      <ambientLight intensity={0.8} />
      <directionalLight position={[10, 10, 10]} />
      <primitive object={scene} scale={2} />
      <OrbitControls />
    </>
  );
}

export default function RingModal({ isOpen, onClose, modelPath }) {
  if (!isOpen) return null;

  return (
    <Overlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>Close</CloseButton>
        <Canvas style={{ height: '400px', width: '100%' }}>
          <BigRingViewer modelPath={modelPath} />
        </Canvas>
      </ModalContent>
    </Overlay>
  );
}
